import * as dinData from '../locales/din/translation.json';
import * as isoData from '../locales/iso/translation.json';

const iso = isoData.default
const din = dinData.default

export const translator = (text) => {
  return iso[text] || text
}